import React from 'react';
import LoginForm from '../components/LoginForm';

const Login = () => {
  return (
    <div className="login-page">
      <LoginForm />
    </div>
  );
};

export default Login;
